import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { useAuthStore } from '@/store/authStore';

/**
 * O dono desativou este membro: toda rota de prestador responde 403. Em vez
 * de telas quebradas, uma frase e a saída.
 */
export function MemberDisabledScreen({ organizationName }: { organizationName: string }) {
  const logout = useAuthStore((s) => s.logout);

  return (
    <View className="flex-1 items-center justify-center gap-3 bg-canvas p-8">
      <View className="h-14 w-14 items-center justify-center rounded-full bg-neutral-100">
        <Ionicons className="text-neutral-500" name="people-outline" size={26} />
      </View>
      <ThemedText className="text-center font-bold text-xl text-neutral-900">
        Você não faz mais parte da equipe {organizationName}
      </ThemedText>
      <ThemedText className="text-center text-sm leading-5 text-neutral-500">
        Se foi engano, fale com quem te chamou.
      </ThemedText>
      <PressableScale
        haptic
        onPress={() => void logout()}
        className="mt-2 h-11 flex-row items-center justify-center rounded-full border border-neutral-200 bg-card px-6"
        style={{ borderCurve: 'continuous' }}
      >
        <ThemedText className="font-semibold text-sm text-neutral-800">Sair da conta</ThemedText>
      </PressableScale>
    </View>
  );
}
